import React, { useContext } from 'react';
import { useToggleWishlistMutation } from '../../redux-modules/service';
import SessionContext from '../../contexts/SessionContext';
import { Favorite } from '../../components/ui/Icons';
import ProductContext from '../../contexts/ProductContext';

export default function Wishlist({
  selectedVariant,
}: {
  selectedVariant: number,
}) {
  const [handleWishlistToggle, { data, isSuccess }] = useToggleWishlistMutation();
  const { product, translates } = useContext(ProductContext);
  const { products } = translates;

  if (isSuccess) {
    // @ts-ignore
    let successMessage = null;
    if (data.items[0].action === 'added') {
      successMessage = Craft.t(products, '{title} is toegevoegd aan je favorieten', {
        title: product.title,
      });
    } else {
      successMessage = Craft.t(products, '{title} is verwijderd van je favorieten', {
        title: product.title,
      });
    }
    const successMessageInput = document.getElementById('notification-success');
    successMessageInput?.setAttribute('value', successMessage);
    htmx.trigger('#notification', 'refresh');
  }

  const session = useContext(SessionContext);
  const { csrfTokenName, csrfTokenValue } = session;

  return (
    <button
      type="button"
      className="flex justify-center items-center w-15.5 h-15 rounded text-near-black hover:text-accent transition-colors border border-near-black"
      onClick={() => {
        const body = new FormData();
        if (csrfTokenName && csrfTokenValue) {
          body.append(csrfTokenName, csrfTokenValue);
        }
        body.append('elementId', selectedVariant.toString());
        body.append('siteId', product.siteId.toString());
        body.append('listType', product.listType);
        handleWishlistToggle(body);
      }}
    >
      <Favorite inList={data !== undefined ? (data.items[0].action === 'added') : product.wishlistItems && product.wishlistItems.includes(selectedVariant)} />
    </button>
  );
}
